<template>
  <div>
    <div class="columns" v-for="(ebooks, index) in chunkedDiscoverEbooks" :key="index">
      <div class="column is-one-fifth" v-for="(ebook, index) in ebooks" :key="index" @click="openEbookModal(ebook)">
        <div class="discover-book">
          <figure class="image is-3by4">
            <img :src="getEbookCover(ebook)">
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chunk from 'chunk'
import ebooksService from '@/services/ebooks.service'

export default {
  name: 'chunkedEbooksDisplay',
  props: {
    ebooks: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getEbookCover (ebook) {
      return ebooksService.getEbookCover(ebook.title, ebook.coverUrl)
    },
    openEbookModal (ebook) {
      this.$store.dispatch('openEbookModal', { ebook })
    }
  },
  computed: {
    chunkedDiscoverEbooks () {
      return chunk(this.ebooks, 5)
    }
  }
}
</script>

<style>
  .discover-book {
    cursor: pointer;
  }
</style>
